<template>
  <div class="center">
    <div class="title">
      {{ newData.name }}
    </div>
    <div class="zp_details">
      <el-row>
        <el-col :span="16">
          <div class="grid-content bg-purple">
            <el-breadcrumb separator="|">
              <el-breadcrumb-item
                >作者 ：{{ newData.username }}</el-breadcrumb-item
              >
              <el-breadcrumb-item
                >{{ label_name }}：{{ newData.from }}</el-breadcrumb-item
              >
              <el-breadcrumb-item
                >发表时间：{{ newData.created_at }}</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <index-icons
              @clickMark="clickMark"
              :activityId="newData.activity_id"
              :workId="newData.id"
              :goodsnum="marks"
              :commentnum="comment"
              :looknum="views"
              :ShowComment="ShowComment"
            ></index-icons>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="zp_text">
      <div class="box">
        <!-- <div class="audio">
            <el-row >
              <el-col :span="2">
                <div class="grid-content left">
                  <span  class="iconfont">&#xe606;</span>
                </div>
              </el-col>
              <el-col class="time" :span="2">
                00:00
              </el-col>
              <el-col :span="17">
                <div class="grid-content">
                  <div class="block">
                    <el-slider v-model="value1"></el-slider>
                  </div>
                </div>
              </el-col>
              <el-col class="time" :span="3">
                00:03:46
              </el-col>
            </el-row>
          </div> -->
        <aplayer
          :music="audio[0]"
          :autoplay="true"
          v-if="flag"
          ref="player"
        ></aplayer>
        <div class="text">
          {{ newData.text }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IndexIcons from "@/components/Icons";
import aplayer from "vue-aplayer";
export default {
  name: "AudioDetails",
  components: {
    IndexIcons,
    aplayer
  },
  props: [
    "audioDetails",
    "commentNum",
    "activityId",
    "ShowComment",
    "ShowComment"
  ],
  data() {
    return {
      newData: "",
      flag: false,
      audio: [],
      marks: "",
      comment: "",
      views: ""
    };
  },
  computed: {
    label_name() {
      let id = this.activityId;
      if (+id === 426) {
        return `参赛者单位`;
      } else {
        return "参赛机构";
      }
    }
  },
  watch: {
    commentNum: function(newval, oldval) {
      console.log(newval);
      this.comment = newval;
    },
    //正确给 newData 赋值的 方法
    audioDetails: function(newVal, oldVal) {
      this.newData = newVal; //newVal即是chartData
      console.log("监听props改变");
      console.log(newVal);
      if (newVal) {
        let obj = {};
        obj.title = newVal.name;
        obj.artist = newVal.username;
        obj.url = newVal.file;
        obj.pic = newVal.image[0];
        this.audio.push(obj);
        this.marks = newVal.mark;
        this.comment = newVal.comment;
        this.views = newVal.views;
      }
      this.flag = true;
    }
  },
  methods: {
    // formatTooltip(val) {
    //   return val / 100;
    // },
    clickMark() {
      this.marks = parseInt(this.marks) + 1;
    }
  }
};
</script>
<style scoped>
.box {
  width: 100%;
  background: white;
  background: #ffffff;
  border-radius: 10px;
}
.center {
  width: 1200px;
  margin: 20px auto;
}
.center .title {
  height: 26px;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin: 30px 0px;
}

.grid-content >>> .comment_icons {
  margin: 0px;
  width: 100%;
  text-align: right !important;
}

.zp_text {
  width: 1200px;
  height: auto;
  background: #ffffff;
  border-radius: 10px;
  margin: 20px 0px;
  padding: 40px 50px;
  box-sizing: border-box;
}
.zp_text .audio {
  width: 100%;
  height: 87px;
  line-height: 87px;
  background: #eef8ee;
  border-radius: 44px;
  box-sizing: border-box;
}
.zp_text .grid-content {
  height: 87px;
  line-height: 87px;
}
.zp_text .iconfont {
  color: #58b75b;
  font-size: 50px;
}
.zp_text .el-slider {
  margin: 0 auto;
}
.zp_text .block {
  margin-top: 25px;
}
.zp_text .left {
  text-align: right;
}
.zp_text .time {
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #58b75b;
}
.zp_text .text {
  width: 100%;
  font-size: 14px;
  color: #333333;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/workdetails/components/audio.vue